module.exports = {

  title: '互联网风险管理平台',
  // title: '舆情数据系统',
  // title: '耳尖舆情数据系统',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
